module.exports = __webpack_public_path__ + "img/qpic_logo.5fc9cf69.svg";